<template>
    <div id="PhysicalCountCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <!-- <span class="page-title" id="itemHeader" v-if="$route.params.id > 0">Update Part Inventory</span> -->
                    <span class="page-title" id="itemHeader">Physical Count</span>
                    <!-- <span id="itemHeader" v-else>Add Component Transaction</span> -->
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="goBackToList" >
                            <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content component-inventory-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="PhysicalCountForm">
                                <div class="form-row row-cols-md-4">
                                    <div class="col form-group">
                                        <label class="control-label" for="countNumber">&nbsp;</label>
                                        <label class="control-label" for="countNumber">Count Number:</label>
                                        <label class="control-label" for="countNumber">{{countNumber}}</label>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="description">Description:</label>
                                        <input type="text" class="form-control" v-model="description" id="description" placeholder="Enter Description" name="description">
                                        <div class="field-error">{{description_error_msg}}</div>
                                    </div>
                                    
                                    <!-- <div class="col form-group">
                                        <label class="control-label require" for="location_id">Warehouse:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                                label="text"
                                                :options="locationArr" :filterable="isComponentFilterable">
                                        </v-select>
                                        <div class="field-error">{{locationerrors}}</div>
                                    </div> -->

                                     <div class="col form-group">
                                        <label class="control-label require" for="location_id">Warehouse:</label>
                                        <v-select v-model="warehouse_id" name="warehouse_id"  @input="changeWarehouse($event)" placeholder="Select Warehouse."
                                                label="text"
                                                :options="warehouseArr">
                                        </v-select>
                                        <div class="field-error">{{warehouseerrors}}</div>
                                    </div>
                                     <div class="col form-group">
                                        <label class="control-label" for="location_id">R/S/B:</label>
                                        <v-select v-model="rsb_id" name="rsb_id" placeholder="R/S/B."
                                                label="text"
                                                :options="rsbArr">
                                        </v-select>
                                        <!-- <div class="field-error">{{rsb_iderror}}</div> -->
                                    </div>
                                      <div class="col form-group">
                                        <label class="control-label" for="component_id">Part:</label>
                                        <v-select v-model="component_id"  name="component_id" label="text" :options="componentArr" @search="onSearchComponent" placeholder="Search Part" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Part...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <div class="field-error">{{ component_error_msg }}</div>
                                    </div>

                                    <div class="col form-group">
                                        <label class="control-label" for="category_id">Category:</label>
                                        <v-select v-model="category_id" name="category_id" placeholder="Select Category."
                                                label="text"
                                                :options="componentCategoryArr">
                                        </v-select>
                                        <!-- <div class="field-error">{{ categoryerrors }}</div> -->
                                    </div>

                                    <div class="col form-group">
                                        <div class="example-label">
                                            <label class="control-label">Count Date</label>
                                        </div>
                                        <div class="input-group">
                                            <date-picker placeholder="MM/DD/YYYY" id="count_date" name="count_date" v-model="count_date" :config="optionsDate" aria-describedby="basic-addon3"></date-picker>
                                            <label for="count_date" class="fp-calendar input-calender-icon" id="basic-addon3"></label>
                                        </div>
                                        <!-- <div class="field-error">{{count_date_error_msg}}</div> -->
                                    </div>
                                    <p>&nbsp;</p>
                                     
                                </div>
                                <div class="form-row row-cols-md-4">
                                    <div class="col form-group">
                                        <label class="control-label">Row/Shelf/Bin Rule:</label>
                                        <div class="custome-radiobtn">
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="ignore_if_zero">Ignore Blank R/S/B if on-hand quantity is zero
                                                    <input type="radio" v-model="rsb_rule" :value="'ignore_if_zero'" id="ignore_if_zero" name="rsb_rule">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                            <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="include"> Include Blank R/S/B
                                                    <input type="radio" v-model="rsb_rule" :value="'include'" id="include" name="rsb_rule">
                                                    <span class="checkmark"></span>
                                                </label>
                                            </div>
                                             <div class="form-check form-check-inline">
                                                <label class="boolean optional radio-custom" for="ignore"> Ignore Blank R/S/B if on-hand quantity is zero;<br> Ignore Non-Blank R/S/B if on-hand quantity is zero AND min/max are zero
                                                    <input type="radio" v-model="rsb_rule" :value="'ignore_non_blank'" id="ignore" name="rsb_rule">
                                                    <span class="checkmark customTop"></span>
                                                </label>
                                            </div>
                                        </div>
                                        <div class="field-error"></div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6 mt-2" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="CreateComponentInventoryBtn" class="btn btn-primary" v-on:click.prevent="CreatePhysicalCount" >
                                        <i class="fp-add"> </i>  Add
                                    </button>
                                    <button type="submit" id="cancelItemBtn" class="btn btn-tertiary" v-on:click.prevent="goBackToList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import {contractMixins} from '../mixins/contractMixins';
export default {
  name: "PhysicalCountCreate",
  
  metaInfo() {
      return {title: "Inventory Count | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins,contractMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    location_id: null,
    locationArr: [],
    loading:false,
    locationerrors:'',
    category_id: null,
    componentCategoryArr: [],
    description_error_msg:'',
    isComponentFilterable:true,
    countNumber:'',
    description:'',
    optionsDate: {
        format: 'MM/DD/YYYY',
        useCurrent: true,
    },
    warehouseerrors:'',
    rsb_iderror:'',
    warehouse_id:'',
    warehouseArr:[],
    rsbArr:[],
    rsb_id:'',
    component_id:'',
    componentArr:[],
    count_date:'',
    rsb_rule:'',
    component_error_msg:''
  }),
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  watch:{
    //check permission change
    permissions: function (permissions) {

        var self = this;
        if (permissions.length > 0) {
            for (var i = 0; i < permissions.length; i++) {
                if (permissions[i].name == 'add_physical_count' ) {
                    self.cantAccessPage = true;
                }
            }
        }

    }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        // console.log("Default " + self.expenseValue);
        self.getPermissions();
        // var path = window.location.pathname;
        // var segments = path.split("/");
        self.getCountNumber();
        this.loadFieldData(['location','component_category','warehouse']);

        if (self.$route.query.inv_id != undefined && self.$route.query.inv_id > 0){
            //self.fetchInventory();
        }else{
            var userObj = JSON.parse(localStorage.getItem("user_obj"));
            if(userObj != null && userObj["location_id"] != null){
                self.location_id =  {value: userObj["location_id"], text: self.titleCase(userObj["locationName"]) + " (" + userObj["locationCode"] + ")"};  
            }
        }
  },
  methods: {

    goBackToList() {
      var self = this;
     
        self.$router.push("/physical-count/list");

    },
    getCountNumber:function(){
        var self = this;

        $.ajax({
            url: process.env.ROOT_API + "/get-physical-count-number",
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                    self.countNumber = data.content;
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'component-by-id')
            }
        });
    },
    
    CreatePhysicalCount(flag) {
        var self = this;
        var error = false;

        self.warehouseerrors = "";
        self.locationerrors = "";
        self.description_error_msg = '';

        if (self.description == null || self.description == '') {
            self.description_error_msg = "Description Required.";
            error = true;
        } 
        if (self.warehouse_id == null || self.warehouse_id == '' || !self.warehouse_id.value) {
            self.warehouseerrors = "Warehouse Required.";
            error = true;
        } 
       
        if (!error) {

            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateComponentInventoryBtn").val("Updating ...");
                $("#CreateComponentInventoryBtn").prop("disabled", true);
                $("#cancelItemBtn").prop("disabled",true);
            }
            
            var fields = $("#PhysicalCountForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            if(self.category_id == null) {
                fields.push({ name: "category_id", value: '' });
            } else {
                fields.push({ name: "category_id", value: self.category_id.value });
            }

            if (self.warehouse_id == null) {
                fields.push({name: "warehouse_id", value: ""});
            } else{
                fields.push({name: "warehouse_id", value: self.warehouse_id.value});
            }
            if (self.warehouse_id != null && self.warehouse_id.location_id) {
                fields.push({name: "location_id", value: self.warehouse_id.location_id});
            } else{
                fields.push({name: "location_id", value: ""});
            }
            if (self.rsb_id != null && self.rsb_id.value) {
                fields.push({name: "rsb_id", value: self.rsb_id.value});
            } else{
                fields.push({name: "rsb_id", value: ""});
            }
             if (self.component_id != null && self.component_id.value) {
                fields.push({name: "component_id", value: self.component_id.value});
            } else{
                fields.push({name: "component_id", value: ""});
            }

            self.loading = true;
            $.ajax({
                url: process.env.ROOT_API + "/physical-count/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateComponentInventoryBtn").val("Update");
                        $("#CreateComponentInventoryBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    }
                    if (data.status == "success") {
                            var batchId = data.batch_id;
                            var batchNum1 = data.batch;
                            self.$router.push("/physical-count/list?from=pin_post&&batch_id="+batchId+"&&num="+batchNum1);


                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateComponentInventoryBtn").val("Update");
                        $("#CreateComponentInventoryBtn").prop("disabled", false);
                        $("#cancelItemBtn").prop("disabled",false);
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'component-create')
                }
            });
        }else{
            self.errorValidationFocus();
        }

    },

    loadItem() {
        
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        
        $.ajax({
            url: process.env.ROOT_API + "/component-inventory/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {

                    if(data.content.itemId == null) {
                        self.component_id = null;
                    }else{
                        self.component_id = {value: data.content.itemId, text: self.titleCase(data.content.itemName + " (" + data.content.itemCode +")")};
                    }

                    if(data.content.location_id == null) {
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.locationName)+' | '+data.content.locCode};
                    }

                    if (data.content.location_row == 0) {
                        self.location_row = "";
                    } else{
                        self.location_row = data.content.location_row;
                    }

                    if (data.content.location_bin == 0) {
                        self.location_bin = "";
                    } else{
                        self.location_bin = data.content.location_bin;
                    }

                    self.location_shelf = data.content.location_shelf;
                    
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'component-by-id')
            }
        });
    },
    onSearchComponent(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            if (self.warehouse_id != null && self.warehouse_id.value){
                self.searchField(loading, search, 'warehouse component', self.warehouse_id.value);

            }else{
                self.searchField(loading, search, 'warehouse component', '');

            }
        }
    },
    changeWarehouse:function(){
        var self = this;

        if (self.warehouse_id != null && self.warehouse_id.value){
            self.loadFieldData(['rsb'],self.warehouse_id.value);
            self.component_id = null;
            self.componentArr = [];
        }
    },
    
    isNumberKey: function(evt) {
        
        var self = this;

        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && (charCode !== 46 || evt.target.value.indexOf('.') != -1)) {
            evt.preventDefault();            
        } else {
            return true;
        }
    },
    titleCase(str) {
        if (str == null){
            return;
        } else{
            var value = str.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
  }
};
</script>

<style scoped>
.customTop{
    top:54px !important;
}
</style>


// WEBPACK FOOTER //
// src/components/PhysicalCountCreate.vue